import type { ReactElement } from "react"

/**
 * The Figma frame draws this as a Font Awesome 6 Pro "play" glyph rather than an
 * exported asset, so there is nothing to download — this is that glyph's path.
 * Decorative: the button's own label carries the meaning.
 */
export const PlayIcon = (): ReactElement => (
  <svg aria-hidden="true" focusable="false" width="13" height="14" viewBox="0 0 384 512" fill="currentColor">
    <path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.3-23-41L73 39z" />
  </svg>
)
